import React, { useEffect, useState, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { bolumeKaydir, kaydirmayiDinle, sayfaKaydirmaY } from '../lib/kaydir'
import '../assets/css/site-yesil.css'

export default function NavbarV2() {
    const [menu, setMenu] = useState<boolean>(false);
    const [scroll, setScroll] = useState<boolean>(false);
    const ticking = useRef(false);
    const navigate = useNavigate();

    useEffect(() => {
        const handleScroll = () => {
            if (!ticking.current) {
                window.requestAnimationFrame(() => {
                    setScroll(sayfaKaydirmaY() > 50);
                    ticking.current = false;
                });
                ticking.current = true;
            }
        };

        return kaydirmayiDinle(handleScroll);
    }, []);

    // Close menu when clicking outside
    useEffect(() => {
        if (menu) {
            // Mobil menü açıkken body scroll'u engelle
            document.body.style.overflow = 'hidden';
            const handleClickOutside = (e: MouseEvent) => {
                const target = e.target as HTMLElement;
                if (!target.closest('.ht-nav-links') && !target.closest('.ht-nav-toggle')) {
                    setMenu(false);
                }
            };
            document.addEventListener('click', handleClickOutside);
            return () => {
                document.body.style.overflow = '';
                document.removeEventListener('click', handleClickOutside);
            };
        } else {
            // Menü kapalıyken scroll'u aç
            document.body.style.overflow = '';
        }
    }, [menu]);

    const links = [
        { to: 'cuz-al', label: 'Ana Sayfa' },
        { to: 'stats', label: 'İstatistikler' },
        { to: 'faqs', label: 'SSS' },
        { to: 'download', label: 'İndir' }
    ];

    return (
        <header className={`ht-nav ${scroll ? 'is-scrolled' : ''}`}>
            <div className="ht-wrap ht-nav-in">
                <Link className="ht-nav-logo" to="/" aria-label="Ana Sayfa">
                    <img src="/assets/images/logo.png" alt="HatimTakip Logo" />
                </Link>
                <nav aria-label="Ana menü">
                    <ul className={`ht-nav-links ${menu ? 'is-open' : ''}`}>
                        {links.map((l) => (
                            <li key={l.to}>
                                <a
                                    href={`/#${l.to}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setMenu(false);
                                        // Ana sayfa dışındaki sayfalarda bölüm yok: ana sayfadaki bölüme git
                                        if (!bolumeKaydir(l.to)) navigate(`/#${l.to}`);
                                    }}
                                >
                                    {l.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
                <div className="ht-nav-right">
                    <button
                        type="button"
                        className="ht-nav-toggle"
                        onClick={() => setMenu(!menu)}
                        aria-label="Menü"
                        aria-expanded={menu}
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
                            {menu ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
                        </svg>
                    </button>
                </div>
            </div>
        </header>
    );
}
